/**
 * TanStack Query hooks for `os-breakdown-widget`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	osBreakdownWidgetQueryKeys,
	type CreateOsBreakdownWidgetBody,
	type ListOsBreakdownWidgetResponse,
	type OsBreakdownWidgetRow,
} from "./api";

export function useOsBreakdownWidgetList(): UseQueryResult<ListOsBreakdownWidgetResponse, Error> {
	return useQuery({
		queryKey: osBreakdownWidgetQueryKeys.list(),
		queryFn: list,
	});
}

export function useOsBreakdownWidgetCreate(): UseMutationResult<OsBreakdownWidgetRow, Error, CreateOsBreakdownWidgetBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: osBreakdownWidgetQueryKeys.all });
		},
	});
}

export function useOsBreakdownWidgetDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: osBreakdownWidgetQueryKeys.all });
		},
	});
}
